import { SummaryStreamType } from "@/constants/record";
import { LinkValidPeriodType, Origin, PermissionChoose, RoleType } from "@/constants/share";

export interface IDetailInfo {
  streamName: string;
  title: string;
  duration: number;
  completeDoc: IDocComplete | null;
  completeDocFinish: boolean;
  srcDoc: IDocComplete | null;
  allowBackUp: boolean;
  allowExport: boolean;
  userId: string;
  origin: string;
  summaryFinish: boolean;
  originType: Origin;
  isOwner: boolean;
  useMarkDownSummary?: boolean;
  createdDate: string;
}

export interface IAudioInfo {
  audioDuration: number;
  audioSrc: string;
  videoSrc?: string; // 视频下载地址
  coverUrl?: string; // 视频封面
  recordStatus: boolean | null; // 录屏是否完成
}

export interface IShareInfo {
  streamId: string;
  shareId?: string;
  password: string;
  origin?: Origin;
  fileTransEnable?: boolean;
}

export interface IAudioResInfo {
  pcmDownloadUrl: string;
  duration: number;
  videoDownloadUrl?: string; // 视频下载地址
  coverUrl?: string; // 视频封面
}

export interface ISpeakerItem {
  speakerName: string[];
  headImage?: string;
  useDefaultIcon?: boolean;
  role: string;
}
export interface WordItem {
  word: string;
  bt: number;
  et: number;
  wi: string;
  mark: boolean;
  formatWord?: string;
  // stableFlag: 0 | 1;
}

export interface IPG {
  /**
   * 发言人字段
   */
  role: string;
  /**
   * 新的发言人字段 以这个为准
   */
  roleName: string;
  speakerName: string[];
  headImage?: string;
  useDefaultIcon?: boolean;
  sc: IPGScItem[];
  mark: boolean;
  id: number;
  pi: string;
  ri?: string;
  bt?: number;
  et?: number;
  endWIndex?: number;
}

export interface IPGScItem {
  isEdited?: boolean; // 前端扩展字段，被编辑过的句子
  withSpeakerName?: boolean;
  bt: number;
  et: number;
  tc: string;
  transTc: string;
  id: number;
  mark: boolean;
  si: string;
  /** 外部关联索引 id，目前做译文和原文的 si 关联 */
  ri?: string;
  words: WordItem[];
  realPara: IPG; // 维护后台真实para，使得编辑的时候可以提交真实的para信息
}

export interface IDocComplete {
  pg: IPG[];
}

export interface ISummary {
  completeAiGcContent: {
    todo: string[];
    content: string[];
    meetingSummary: string[];
  };
  srcAiGcContent: {
    todo: string[];
    content: string[];
    meetingSummary: string[];
  };
  summaryFinish: boolean;
  streamName: string;
}

export interface IStreamLoading {
  meetingSummaryLoading: boolean;
  contentLoading: boolean;
  todoLoading: boolean;
}

export interface IStreamClose {
  closeMethod?: () => void;
  closeStatus: boolean;
}
export interface IStreamCloseMap {
  [SummaryStreamType.meetingSummary]: IStreamClose;
  [SummaryStreamType.content]: IStreamClose;
  [SummaryStreamType.todo]: IStreamClose;
}

export interface IChapterApi {
  /**
   * 智能章节
   */
  complateChapterList: IChapterList[] | null;
  /**
   * 原文版智能章节
   */
  srcChapterList: IChapterList[] | null;
  summaryFinish: boolean;
}

export interface IChapterList {
  /**
   * 结束时间
   */
  endtime: number;
  /**
   * 分段关键词 原文版没有这个字段
   */
  keyWordList?: IKeyWordList[];
  /**
   * 开始时间
   */
  starttime: number;
  /**
   * 总结内容
   */
  summary: string;
  /**
   * 主题
   */
  topic: string;
}

export interface IKeyWordList {
  /**
   * 个数
   */
  count: number;
  /**
   * 关键词
   */
  key: string;
}

export interface ISpeakerSummaryApi {
  /**
   * 优化版发言人总结
   */
  completeSpeakers: ISpeakerSummary[] | null;
  /**
   * 原文发言人总结
   */
  srcSpeakers: ISpeakerSummary[] | null;
  summaryFinish: boolean;
}

export interface ISpeakerSummary {
  /**
   * 总结内容
   */
  content: string;
  /**
   * 发言人 即将废弃
   * @deprecated
   */
  role: string;
  /**
   * 发言人
   */
  roleName: string;
  speakerName: string[];
  headImage: string;
  useDefaultIcon: boolean;
}

export interface IGetAudioUrlParams {
  streamName: string;
}

export interface IGetMeetingDetailParams {
  recordingType: string;
  streamId: string;
}

export interface IGetMeetingSummaryParams {
  streamName: string;
  reload: boolean;
  cover: boolean;
  contentStep: string;
}
export interface IShareLinkInfo {
  /**
   * 密码
   */
  password: string;
  /**
   * 录制时间
   */
  recordingTime: string;
  /**
   * 会议名称
   */
  showName: string;
  /**
   * 流名称
   */
  streamName: string;
  /**
   * 分享链接
   */
  url: string;
  shareId: string;
  allowBackUp: boolean;
  allowExport: boolean;
  linkValidity: LinkValidPeriodType;
  shareScope: PermissionChoose;
  waterMarkEnable: boolean;
  expiredTime: Date;
}

export enum ESummaryType {
  MEETING_SUMMARY = "MEETING_SUMMARY",
  SMART_CHAPTERS = "SMART_CHAPTERS",
  SPEAKER_SUMMARY = "SPEAKER_SUMMARY",
}

export interface ISummaryEditContent {
  meetingSummary?: {
    completeSummary?: ISummary["completeAiGcContent"];
    summary?: ISummary["completeAiGcContent"];
    summaryFinish: boolean;
  };
  smartChapters?: {
    complateChapterList?: IChapterList[];
    srcChapterList?: IChapterList[];
  };
  meetingSpeakerSummary?: { completeSpeakers?: ISpeakerSummary[]; srcSpeakers?: ISpeakerSummary[] };
}

export interface ICreateShareParams {
  streamName: string;
  platform: "WEB" | "ANDROID" | "IOS";
  allowBackUp?: boolean;
  password?: string;
}

export interface FetchSummaryCommonParams {
  streamName: string;
  reload: boolean;
  contentStep: string;
  cover: boolean;
}

export interface FetchSummaryStreamParams extends FetchSummaryCommonParams {
  meetingSummaryEvent: string;
}

export interface fetchSummaryStreamsRes {
  summaryEvSClose: () => void;
  contentEvSClose: () => void;
  todoEvSClose: () => void;
}

export interface MeetingTitleData {
  streamName: string;
  title: string;
  srcTitleSummary: string;
  completeTitleSummary: string;
}

export interface IKeyframeItem {
  keyFrameFilekey: string;
  keyFrameUrl: string;
  beginTimestamp: number;
  endTimestamp: number;
  chapterIndex?: number;
  keyframeIndex?: number;
}
export interface IBackTraceItem {
  [pi: string]: {
    content: string;
    si: string[];
  };
}

export interface IBackTrace {
  [key: string]: IBackTraceItem[],
}


export interface BackTraceData {
  summaryBackTrace: IBackTrace;
  contentBackTrace: IBackTrace;
  todoBackTrace: IBackTrace;
}

export interface IFormatBackTraceArr {
  sIds: string[];
  pi: string;
  pIndex: number;
  sIndex: number;
}
export interface IFormatBackTrace {
  [key: string]: IFormatBackTraceArr[],
}

export interface FormatBackTraceData {
  summaryBackTrace: IFormatBackTrace;
  contentBackTrace: IFormatBackTrace;
  todoBackTrace: IFormatBackTrace;
}
export type BackTraceType = "summaryBackTrace" | "contentBackTrace" | "todoBackTrace";


export interface IUpdateBackTraceParam {
  streamName: string;
  meetingSummaryEvent: string;
  backTrace: IBackTrace;
}

export interface INewBackTraceIds {
  summaryBackTrace: string[];
  contentBackTrace: string[];
  todoBackTrace: string[];
}

export interface MeetingPermissionData {
  sharePermission: RoleType;
}

export interface IOriginalData {
  pg?: IPG[];
  transPg?: IPG[];
  stashPg?: IPG[];
  stashTransPg?: IPG[];
}

export interface IUpdateTransText {
  // UPDATE 时要传 editNote
  editNote?: IOriginalData;
  // DELETE 时要传 pis
  pis?: string[];
  optEventType: 'UPDATE' | 'DELETE';
  streamName: string;
}

export interface IModifyRoleParams {
  streamName: string;
  pis: string[];
  role: string;
  roleName: string;
  editRoleType: "ONE" | "BATCH";
}